export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/stop-icon.svg?ad9bb391b8fa3c8ce16955edbb961d8f";